import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload', 'upload', 'Augšupielādēt');
Labels.set('ui-upload', 'uploadFiles', 'Augšupielādējiet failus');
Labels.set('ui-upload', 'clear', 'Noņemt failu');
